import { render, staticRenderFns } from "./VenueGeneral.vue?vue&type=template&id=4675ef24&scoped=true&"
import script from "./VenueGeneral.vue?vue&type=script&lang=js&"
export * from "./VenueGeneral.vue?vue&type=script&lang=js&"
import style0 from "./VenueGeneral.vue?vue&type=style&index=0&id=4675ef24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675ef24",
  null
  
)

export default component.exports